import { useAuth } from '../context/AuthContext';
import { NotificationPreferences } from 'notification-kit/client/index.js';

export function ProfilPage() {
  const { user, roles } = useAuth();

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Profil</h1>
          <p className="page-meta">{user?.email}</p>
        </div>
      </div>

      <div className="card mb-16">
        <div className="card-header">
          <span className="card-title">Compte</span>
        </div>
        <div className="p-16 flex flex-col gap-8">
          <div className="flex gap-8 items-center">
            <div className="user-initial">{user?.initials}</div>
            <div>
              <div className="font-medium text-ink-1">{user?.name}</div>
              <div className="text-sm text-ink-3">{user?.email}</div>
            </div>
          </div>
          <div className="flex gap-4">
            {user?.isAdmin && <span className="badge badge-accent">Admin</span>}
            {roles.map((r) => (
              <span key={r} className="badge">{r}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">Préférences de notification</span>
        </div>
        <div className="p-16">
          <NotificationPreferences />
        </div>
      </div>
    </div>
  );
}
